export default __webpack_public_path__ + "static/icon-tile-dark-a4ac946a10175b907ab7f70c9f743f88416a1935da11df986cc10b5d0832e55e.png";